<template>
  <div>
    <template v-if="!profil.id_user">
      <template v-if="!status.message">
        <p v-if="isOnline" class="ma-2">Loading...</p>
        <p v-else class="ma-2">Koneksi bermasalah!</p>
      </template>
      <p v-else class="ma-2">{{ status.message }}</p>
    </template>
    <template v-else>
      <v-app :dark="$vuetify.dark">
        <template v-if="!id_laman$">
          <welcome-screen></welcome-screen>
        </template>
        <template v-else>
          <!-- Sidebar -->
          <app-sidebar></app-sidebar>
          <!-- Top Toolbar -->
          <app-toolbar></app-toolbar>
          <!-- Main Content -->
          <v-content>
            <!-- The Page -->
            <page-header
              v-if="
                !$route.meta.error &&
                !$route.meta.noMenu &&
                !($vuetify.breakpoint.xs && $route.query.id)
              "
            ></page-header>
            <div v-else class="mt-4"></div>
            <v-container
              class="pt-0"
              grid-list-lg
              :fill-height="$route.meta.error"
              fluid
            >
              <!-- option : fluid, fill-height -->
              <!-- <transition> -->
              <!-- <v-slide-y-reverse-transition hide-on-leave> -->
              <keep-alive>
                <router-view></router-view>
              </keep-alive>
              <!-- </v-slide-y-reverse-transition> -->
              <!-- </transition> -->
            </v-container>
          </v-content>
          <!-- Go to top -->
          <!-- <app-fab></app-fab> -->
          <!-- Theme Setting (Right Sidebar) -->
          <!-- <app-theme-settings></app-theme-settings> -->
        </template>
        <!-- Snackbar -->
        <app-snackbar></app-snackbar>
        <!-- overlay prgoress -->
        <v-dialog v-model="processing" persistent width="300">
          <v-card color="primary" dark>
            <v-card-text>
              <template v-if="upload_progress < 100">
                <span class="white--text"
                  >Mengunggah file...
                  <small> ({{ upload_progress }}%)</small>
                </span>
                <v-progress-linear
                  v-model="upload_progress"
                  color="white"
                  class="mb-0"
                >
                </v-progress-linear>
              </template>
              <template v-else>
                <span class="white--text">Harap sabar...</span>
                <v-progress-linear indeterminate color="white" class="mb-0">
                </v-progress-linear>
              </template>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-app>
    </template>
  </div>
</template>


<script>
import colors from "vuetify/es5/util/colors";
import AppToolbar from "@/components/app/AppToolbar";
import AppSidebar from "@/components/app/AppSidebar";
import AppThemeSettings from "@/components/app/AppThemeSettings";
import AppFab from "@/components/app/AppFab";
import AppSnackbar from "@/components/app/AppSnackbar";
import WelcomeScreen from "@/components/app/WelcomeScreen";
import PageHeader from "@/components/app/PageHeader";
import { mapState } from "vuex";

export default {
  name: "private",
  components: {
    AppToolbar,
    AppSidebar,
    AppThemeSettings,
    AppFab,
    AppSnackbar,
    WelcomeScreen,
    PageHeader
  },
  data() {
    return {
      colors: colors,
      themeColor: this.$store.state.ui.themeColor,
      lightOption: this.$store.state.ui.lightOption
    };
  },
  computed: {
    ...mapState(["status", "load", "id_laman$"]),
    ...mapState("auth", ["profil", "authenticated"]),
    upload_progress: {
      get() {
        return this.$store.state.upload_progress;
      },
      set() {}
    },
    processing: {
      get() {
        return this.$store.state.processing;
      },
      set() {}
    }
  },
  methods: {
    init() {
      let route = this.$route.name;
      if (route == "Materi") {
        this.$store.dispatch("materi/GET_MATERI");
        this.$store.dispatch("materi/GET_OPTIONS");
      } else if (route == "TrainingList" || route == "TrainingSaya") {
        this.$store.dispatch("training/GET_TRAINING");
        this.$store.dispatch("training/GET_OPTIONS");
      } else if (route == "TrainerList" || route == "LaporanTrainer") {
        this.$store.dispatch("trainer/GET_TRAINER");
        this.$store.dispatch("trainer/GET_OPTIONS");
      } else if (route == "TrainerDivisi") {
        this.$store.dispatch("trainer_divisi/GET_TRAINER_DIVISI");
      } else if (route == "ClientList" || route == "LaporanClient") {
        this.$store.dispatch("client/GET_CLIENT");
        this.$store.dispatch("client/GET_OPTIONS");
      } else if (route == "ClientArea") {
        this.$store.dispatch("area/GET_AREA");
        this.$store.dispatch("area/GET_OPTIONS");
      } else if (route == "LaporanTraining") {
        this.$store.dispatch("pel_client/GET_PEL_CLIENT");
      } else if (route == "User") {
        this.$store.dispatch("user/GET_USER");
        this.$store.dispatch("user/GET_OPTIONS");
      } else if (route == "Sistem") {
        this.$store.dispatch("sistem/GET_SISTEM");
      } else if (route == "Dashboard") {
        this.$store.dispatch("materi/GET_MATERI");
        this.$store.dispatch("training/GET_TRAINING");
        this.$store.dispatch("trainer/GET_TRAINER");
        this.$store.dispatch("trainer_divisi/GET_TRAINER_DIVISI");
        this.$store.dispatch("client/GET_CLIENT");
        this.$store.dispatch("area/GET_AREA");
        this.$store.dispatch("user/GET_USER");
      }
    },
    initAll() {
      this.$store.dispatch("training/GET_TRAINING");
      this.$store.dispatch("training/GET_OPTIONS");
      this.$store.dispatch("trainer/GET_TRAINER");
      this.$store.dispatch("trainer/GET_OPTIONS");
      this.$store.dispatch("trainer_divisi/GET_TRAINER_DIVISI");
      this.$store.dispatch("client/GET_CLIENT");
      this.$store.dispatch("client/GET_OPTIONS");
      this.$store.dispatch("area/GET_AREA");
      this.$store.dispatch("area/GET_OPTIONS");
      this.$store.dispatch("materi/GET_MATERI");
      this.$store.dispatch("materi/GET_OPTIONS");
      this.$store.dispatch("user/GET_USER");
      this.$store.dispatch("user/GET_OPTIONS");
      this.$store.dispatch("sistem/GET_SISTEM");
      this.$store.dispatch("pel_client/GET_PEL_CLIENT");
    }
  },
  watch: {
    load(val) {
      if (val) {
        this.init();
      }
    },
    authenticated(val) {
      if (val) this.initAll();
    },
    isOnline(val) {
      if (val) {
        this.initAll();
      }
    }
  },
  created() {
    // set layout
    this.$vuetify.theme.primary = this.colors[this.themeColor].base;
    this.$vuetify.theme.secondary = this.colors[this.themeColor].lighten2;
    this.$vuetify.dark = this.lightOption === "dark";
  },
  mounted() {
    if (!this.$store.state.auth.profil.id_user) {
      this.$store.dispatch("auth/RESOLVE_TOKEN");
    }
    this.initAll();
  }
};
</script>
